export default __webpack_public_path__ + "static/media/StorageContainer.256.f77a7b7d.png";